import { Capacitor } from '@capacitor/core';
import { UserAlertDay, UserAlertFrequency } from '../../../../../backend/src/types.generated';
import { GetUserAccountAlertsQuery } from '../graphql.generated';
import { CapacitorNotificationsManager } from './capacitor-notifications-manager';
import { WebNotificationsManager } from './web-notifications-manager';

export type Alert = NonNullable<GetUserAccountAlertsQuery['user']>['userAlerts'][number];

export interface NotificationSettings {
	enabled?: boolean;
	frequency?: UserAlertFrequency;
	day?: UserAlertDay;
	time?: string;
	from?: string;
	id?: string;
}

export interface NotificationsManagerImplementation {
	readonly notificationsEnabled: (currentUser: { id: string }) => Promise<boolean>;
	readonly listNotifications: (currentUser: { id: string }) => Promise<Alert[]>;
	readonly notificationSettingsValuesChanged: (
		currentUser: { id: string },
		notificationSettings: NotificationSettings
	) => Promise<NotificationSettings>;
	readonly notificationSettings: (currentUser: {
		id: string;
	}) => Promise<NotificationSettings | null>;
}

export const NotificationsManager = Capacitor.isNativePlatform()
	? new CapacitorNotificationsManager()
	: new WebNotificationsManager();
